import React from 'react';
import { ContactFragment } from '../../../generated/graphql';
import { IconButton, Stack, Typography } from '@mui/material';
import { formatContactRole } from '../../../lib/format-contact-role';
import { formatContact } from '../../../lib/format-contact';
import { RemoveItemIcon } from '../../../components/icons';
interface ContactListProps {
  contacts: ContactFragment[];
  onRemove: (c: ContactFragment) => void;
  onClick: (c: ContactFragment) => void;
  disabled?: boolean;
}

export function ContactList(props: ContactListProps) {
  const { contacts, onRemove, onClick, disabled } = props;

  return (
    <Stack width="100%" spacing={1}>
      {contacts.length === 0 && <p>Žiadne kontakty nie sú zahrnuté v tomto prenájme.</p>}
      {contacts.map((c) => {
        return (
          <Stack alignItems="center" direction="row" key={c.id} sx={{ cursor: 'pointer' }}>
            <IconButton onClick={() => onRemove && onRemove(c)} disabled={disabled}>
              <RemoveItemIcon />
            </IconButton>

            <Typography variant="body1" sx={{ flexGrow: 1 }} onClick={() => onClick(c)}>
              {'(' + formatContactRole(c.role) + ') ' + formatContact(c)}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
}
